// extracted by mini-css-extract-plugin
export var actions = "_t4-4";
export var item = "_t4-1";
export var price = "_t4-3";
export var quantity = "_t4-2";
export var table = "_t4-0";